import { Component, EventEmitter, Input, Output } from "@angular/core";
import { JobOffer, StageUpdateEvent } from "../../../../../../api/job-offer/job-offer.types";
import { CmsNameValue } from "../../../../../../api/cms/cms.types";
import { Router } from "@angular/router";
import { JobOfferService } from "../../../../../../api/job-offer/job-offer.service";
import { NzNotificationService } from "ng-zorro-antd/notification";
import { TranslateService } from "@ngx-translate/core";
import { APP_CONFIGURATION } from "../../../../../../../../../core/src/lib/core.di";
import { Inject } from "@angular/core";
import { AppConfig } from "../../../../../../../../../core/src/lib/app-config/config.types";
import { CmsFeatureType } from "../../../../../../api/cms/cms.types";

@Component({
  selector: "mh-job-offer-list-active",
  templateUrl: "./job-offer-list-active.component.html",
  styleUrls: ["./job-offer-list-active.component.less"],
})
export class JobOfferListActiveComponent {
  @Input() jobOfferList: Array<JobOffer> = [];
  @Input() hasReviewedStatus = false;
  @Input() stage?: CmsNameValue;
  @Output() archiveJobOffer = new EventEmitter<JobOffer>();
  @Output() stageUpdated = new EventEmitter<StageUpdateEvent>();
  @Output() publishStatusChanged = new EventEmitter<JobOffer>();

  constructor(
    private router: Router,
    private jobOfferService: JobOfferService,
    private notification: NzNotificationService,
    private translate: TranslateService,
    @Inject(APP_CONFIGURATION) private appConfiguration: AppConfig,
  ) {}

  get isJobOpportunityPublishingEnabled(): boolean {
    return this.appConfiguration.featureStatus.jobOpportunityPublishing;
  }

  get filteredJobOffers(): Array<JobOffer> {
    if (this.stage) {
      return this.jobOfferList.filter((offer) => offer.stage === this.stage?.value);
    }
    return this.jobOfferList;
  }

  onArchive(entity: JobOffer) {
    this.archiveJobOffer.emit(entity);
  }

  onStageUpdated(event: StageUpdateEvent) {
    this.stageUpdated.emit(event);
  }

  onPublish(offer: JobOffer) {
    this.jobOfferService.publishJobOpportunity(offer.id).subscribe({
      next: (success) => {
        if (success) {
          const updatedOffer = { ...offer, published: true };
          this.publishStatusChanged.emit(updatedOffer);
          this.notification.success(
            this.translate.instant("job-opportunity.publish.success.title"),
            this.translate.instant("job-opportunity.publish.success.message"),
          );
        }
      },
      error: () => {
        this.notification.error(
          this.translate.instant("job-opportunity.publish.error.title"),
          this.translate.instant("job-opportunity.publish.error.message"),
        );
      },
    });
  }

  onUnpublish(offer: JobOffer) {
    this.jobOfferService.unpublishJobOpportunity(offer.id).subscribe({
      next: (success) => {
        if (success) {
          const updatedOffer = { ...offer, published: false };
          this.publishStatusChanged.emit(updatedOffer);
          this.notification.success(
            this.translate.instant("job-opportunity.unpublish.success.title"),
            this.translate.instant("job-opportunity.unpublish.success.message"),
          );
        }
      },
      error: () => {
        this.notification.error(
          this.translate.instant("job-opportunity.unpublish.error.title"),
          this.translate.instant("job-opportunity.unpublish.error.message"),
        );
      },
    });
  }

  navigateToMatches(offerId: string) {
    this.router.navigate(["/", "mission-partner", "job-offers", "matches", offerId]);
  }
}
